import {translations} from '../../../../environments/translations.ru';
import {Columns} from "compob2b-table";

export const DAM_SHARE_FORM: Columns[] = [
  {
    key: 'header',
    title: translations.header,
    placeholder: translations.header,
    searchEnabled: false,
    formly: true,
    grid: true,
    type: 'input',
    required: true,
    width: '10%',
  },
  {
    key: 'startDate',
    title: translations.startDate,
    placeholder: translations.startDate,
    searchEnabled: false,
    formly: true,
    className: 'date-box',
    grid: true,
    type: 'datepicker-input',
    required: false,
    width: '100%',
    defaultValue: new Date(),
    templateOptions: {
      label: translations.startDate,
      type: 'timestamp',
      required: false
    },
  },
  {
    key: 'endDate',
    title: translations.endDate,
    placeholder: translations.endDate,
    searchEnabled: false,
    formly: true,
    grid: true,
    className: 'date-box',
    type: 'datepicker-input',
    required: false,
    width: '100%',
    defaultValue: new Date(),
    templateOptions: {
      label: translations.endDate,
      type: 'timestamp',
      required: false
    },
  },
  {
    key: 'enabled',
    title: translations.enabled,
    placeholder: translations.enabled,
    searchEnabled: false,
    formly: true,
    grid: true,
    defaultValue: true,
    width: '10%',
    type: 'checkbox',
    required: true
  },
  {
      key: 'action',
      title: translations.action,
      placeholder: translations.action,
      searchEnabled: false,
      orderEnabled: false,
      grid: true,
      formly: false,
      width: '20%',
      type: 'input',
      required: true
  }
];
